/* eslint-disable react/prop-types */
import React from 'react';
import numeral from 'numeral';
import { map } from 'lodash';
import { Link } from 'react-router-dom';

export const formatShows = ({ data = [], fields = {} } = {}) =>
  map(data, show => ({
    show: show[fields.show],
    showId: show[fields.showId],
    network: show[fields.network],
    networkId: show[fields.networkId],
    followers: show[fields.followers],
    viewers: show[fields.viewers],
    views: show[fields.views],
    viewshare: show[fields.viewshare],
    completion: show[fields.completion],
    engagement: numeral(show[fields.engagement]).format('0.00')
  }));

export const defaultSorts = ['viewshare'];

export const columns = [
  {
    Header: '',
    accessor: (row, i) => i + 1,
    id: 'index',
    className: 'tvt-tabular-data-table__show-ranker-rank'
  },
  {
    Header: 'Show',
    accessor: 'show',
    className: 'tvt-tabular-data-table__show-ranker-show',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/show/${original.showId}`}>{value}</Link>
    )
  },
  {
    Header: 'Network',
    accessor: 'network',
    className: 'tvt-tabular-data-table__show-ranker-network',
    Cell: ({ row: { original }, cell: { value } }) => (
      <Link to={`/network/${original.networkId}`}>{value}</Link>
    )
  },
  {
    Header: 'Followers',
    accessor: 'followers',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-ranker-followers',
    sortDescFirst: true,
    hoverTitle:
      'Number of users who expressed interest or intent to view a specific show or movie by adding it to their watch list'
  },
  {
    Header: 'Viewers',
    accessor: 'viewers',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-ranker-viewers',
    sortDescFirst: true,
    hoverTitle:
      'Unique count of users who tracked (in the app) an episode, season, show or movie'
  },
  {
    Header: 'Views',
    accessor: 'views',
    Cell: ({ cell: { value } }) => numeral(value).format('0,0'),
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-ranker-views',
    sortDescFirst: true,
    hoverTitle:
      'Count of episodes or movies marked as watched (tracked) within the app'
  },
  {
    Header: 'Share of Views',
    accessor: 'viewshare',
    Cell: ({ cell: { value } }) => `${numeral(value * 100).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-ranker-share-views caret-center',
    sortDescFirst: true,
    sortType: 'basic',
    hoverTitle:
      'The portion of all Views, for selected filter criteria, belonging to a specific piece of content'
  },
  {
    Header: 'Completion Rate',
    accessor: 'completion',
    Cell: ({ cell: { value } }) => `${numeral(value * 100).format('0.00')}%`,
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-ranker-completion caret-center',
    sortDescFirst: true,
    hoverTitle:
      'Episode Completion Rate is the percent of available episodes watched among show viewers. This metric reflects percentage of content viewed; not percent of users who have completed'
  },
  {
    Header: 'Engagement Score',
    accessor: 'engagement',
    className:
      'tvt-tabular-data-table__td-kpi tvt-tabular-data-table__show-ranker-engagement caret-center',
    sortDescFirst: true,
    hoverTitle:
      'Robust measure of in-app engagement actions around a program. Higher weight for more active actions (i.e. creating comment or meme) & lower weight for less active (i.e. voting, liking)'
  }
];

export default { columns, formatShows, defaultSorts };
